<template>
    <div class="summary-section">
        <!-- Status Container (cards + progress bar) -->
        <div class="status-container">
            <!-- Status Cards -->
            <div class="status-row">
                <div 
                    v-for="statusCard in statusCards" 
                    :key="statusCard.value"
                    class="status-card"
                    :style="{ borderColor: statusCard.color }"
                >
                    <i 
                        :class="'fa ' + statusCard.icon" 
                        :style="{ color: statusCard.color }"
                        class="status-icon"
                    ></i>
                    <span class="status-count" :style="{ color: statusCard.color }">
                        {{ statusCard.count }}
                    </span>
                    <span class="status-label">{{ statusCard.label }}</span>
                </div>
                <!-- Total -->
                <div class="status-card total-card">
                    <i class="fa fa-list status-icon"></i>
                    <span class="status-count">{{ summary.total_plans }}</span>
                    <span class="status-label">Total</span>
                </div>
            </div>

            <!-- Progress Bar (Cerrados vs Total) -->
            <div class="progress-bar-inline">
                <div 
                    class="progress-fill"
                    :style="{ width: completedPercentage + '%' }"
                    :title="'Cerrados: ' + completedCount + ' de ' + summary.total_plans"
                ></div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TracingSummaryCards',
    props: {
        summary: {
            type: Object,
            required: true,
        },
    },
    computed: {
        statusCards() {
            const byStatus = this.summary.by_status || {};
            const cards = [];

            // Add status cards from backend
            Object.keys(byStatus).forEach(key => {
                const status = byStatus[key];
                cards.push({
                    value: key,
                    label: status.label || key,
                    count: status.count || 0,
                    color: status.color || '#6B7280',
                    icon: status.icon || 'fa-circle',
                });
            });

            return cards;
        },
        pendingCount() {
            const byStatus = this.summary.by_status || {};
            const abierto = byStatus.abierto ? byStatus.abierto.count : 0;
            const proceso = byStatus.proceso ? byStatus.proceso.count : 0;
            return abierto + proceso;
        },
        completedCount() {
            const byStatus = this.summary.by_status || {};
            const cerrado = byStatus.cerrado ? byStatus.cerrado.count : 0;
            const cerradoPorVerificar = byStatus.cerrado_por_verificar ? byStatus.cerrado_por_verificar.count : 0;
            return cerrado + cerradoPorVerificar;
        },
        pendingPercentage() {
            const total = this.summary.total_plans || 0;
            if (total === 0) return 0;
            return Math.round((this.pendingCount / total) * 100);
        },
        completedPercentage() {
            const total = this.summary.total_plans || 0;
            if (total === 0) return 0;
            return Math.round((this.completedCount / total) * 100);
        },
    },
};
</script>

<style scoped>
.summary-section {
    margin-bottom: 20px;
}

/* Status Container (like filters container) */
.status-container {
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px;
}

/* Status Cards Row (priority-style) */
.status-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin-bottom: 12px;
}

.status-card {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px 14px;
    transition: all 0.2s ease;
}

.status-card:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.status-icon {
    font-size: 0.9rem;
}

.status-count {
    font-size: 1rem;
    font-weight: 700;
}

.status-label {
    font-size: 0.85rem;
    color: #6b7280;
}

.total-card {
    border-color: #3B82F6;
}

.total-card .status-icon,
.total-card .status-count {
    color: #3B82F6;
}

/* Progress Bar Inline */
.progress-bar-inline {
    height: 6px;
    background: #e5e7eb;
    border-radius: 3px;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    background: #3B82F6;
    border-radius: 3px;
    transition: width 0.3s ease;
}

@media (max-width: 992px) {
    .status-row {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 576px) {
    .status-row {
        grid-template-columns: 1fr 1fr;
    }
}
</style>
